function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}


customElements.define("header-new", class HeaderNew extends HTMLElement{
  constructor(){
    super()

    this.header = this.querySelector('.header')
    this.isHomePage = this.parentElement.classList.contains('header-new--home')
    this.isHomePage && window.innerWidth > 1400 && (this.parentElement.style.marginBottom = "-" + this.offsetHeight + "px")
    this.menuItems = this.querySelectorAll('.header-item-new__menu-item')
    this.mobileTabs = this.querySelectorAll('.js-toggle-submenu')

    window.addEventListener("resize", ()=>{
      if(window.innerWidth > 1400){
        this.isHomePage && (this.parentElement.style.marginBottom = "-" + this.offsetHeight + "px")
      }else{
        this.isHomePage && (this.parentElement.style.marginBottom = "0px")
      }
    })
    if(this.isHomePage){
      window.addEventListener("scroll", ()=>{
        if(window.scrollY > 0){
          this.parentElement.classList.remove('header-new--home')
        }else{
          this.parentElement.classList.add('header-new--home')
        }
      })
    }

    this.mobileTabs.forEach(tab=>tab.addEventListener('click', ()=>{
      console.log(tab.dataset.submenuId)
      this.mobileTabs.forEach(tab=>tab.classList.remove('active'))
      this.querySelectorAll('.menu-drawer__menu-item').forEach(item=>item.classList.add('hidden'))
      tab.classList.add('active')
      this.querySelector('.menu-drawer__menu-item[data-submenu-id="'+tab.dataset.submenuId+'"]').classList.remove('hidden')
    }))


    this.menuItems.forEach(item => {
      item.addEventListener('mouseenter', ()=>{
        console.log(item)
        const rightImage = item.dataset.rightImage
        console.log(rightImage)
        if(rightImage){
          this.querySelector('.header-new-item__submenu-right img').src = rightImage
        }
      })
    })
  }
})

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const header = document.querySelector('.shopify-section-group-header-group')
    const announcement = document.querySelector('.announcement-bar')
    if(!header) return
    document.body.style.setProperty('--header-height', `${header.offsetHeight + announcement.offsetHeight}px`);
  }, 0)
})

window.addEventListener('scroll', ()=>{
  setTimeout(() => {
    const header = document.querySelector('.shopify-section-group-header-group')
    const announcement = document.querySelector('.announcement-bar')
    if(!header) return
    document.body.style.setProperty('--header-height', `${header.offsetHeight}px`);
  }, 0)
})

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value && event.target.name === "plus"){
      fetch(`${routes.cart_url}?view=max_items`)
        .then(res=>res.json())
        .then(res=>{
          const cartMaxItems = parseInt(document.querySelector('.cart-drawer').dataset.maxItems)
          const quantity = parseInt(res.total_items)
          if(quantity>=cartMaxItems && event.target.name === 'plus'){
            // alert("Error")
            this.input.value = this.input.value - 1
            document.querySelector('cart-drawer .product-form__max-quantity-error').classList.remove("hidden")
            document.querySelector('.cart__blocks .product-form__max-quantity-error').classList.remove("hidden")
            return
          }else if(quantity>=cartMaxItems){
            this.input.value = cartMaxItems - 1 
            this.input.dispatchEvent(this.changeEvent);
          }else{
            this.input.dispatchEvent(this.changeEvent);
          }
        })
    }else{
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');

        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      console.log("ADIOS")
      // if (!window.scrollY > 0) {
      //   document.querySelector('.header-wrapper').classList.add('header-transparent-true')
      // }
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      console.log("HOLA")
      document.querySelector('.header-wrapper').classList.remove('header-transparent-true')
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('a.see-locales-btn'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.elements.panel.addEventListener('focusout', this.hidePanel.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a:not(.see-locales-btn)').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector(event) {
    event.preventDefault();
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const target = event.relatedTarget;
    if (target && (target.classList.contains('locales-list') || target.closest(".locales-list"))) return;
    this.hidePanel();
  }
}

customElements.define('localization-form', LocalizationForm);


class videoPopup extends HTMLElement {
  constructor() {
    super();
    this.playBtn = this.querySelector('.play-btn');
    this.videoSources = this.playBtn.dataset.videoSources;
    this.sourcesArr = this.videoSources.split(',').filter(item => item).map(item => {
      const itemParts = item.split('_|_');
      console.log("Check?", itemParts, item, this.videoSources)
      return {
        href: itemParts[0],
        type: 'video',
        source: itemParts[1]
      }
    });
    console.log("sourcesArr", this.sourcesArr)
    this.startIndex = this.playBtn.dataset.startIndex;
    this.addEventListener('click', () => {
      const myGallery = GLightbox({
        svg: {
          next: `<svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
                </svg>`,
          prev: `<svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
                </svg>`,
          close: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                    <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                  </svg>`
        },
        elements: this.sourcesArr,
        touchNavigation: true,
        loop: true,
        autoplayVideos: true,
        startAt: this.startIndex
      });
      myGallery.open();
    })
  }
}

customElements.define('video-popup', videoPopup);

class ShareBlock extends HTMLElement {
  constructor() {
    super();
    this.querySelector('.fb-share').href = `https://www.facebook.com/sharer/sharer.php?u=${window.location}`;
    this.querySelector('.tw-share').href = `https://twitter.com/intent/tweet?text=${window.location}`;
    this.querySelector('.copy-to-cb').addEventListener('click', () => {
      navigator.clipboard.writeText(window.location);
    })
  }
}

customElements.define('share-block', ShareBlock);


class IngredientsLightbox extends HTMLElement {
  constructor() {
    super();
    this.allCards = Array.from(this.querySelectorAll(`.${this.dataset.cardClass}`));
    this.lightbox = document.createElement('div');
    this.lightbox.classList = 'ing-lightbox';

    this.uniqueId = `swiper-${Math.floor(Math.random() * 1000) + 322}id`;

    this.slider = document.createElement('div');
    this.slider.classList = `${this.uniqueId} swiper`;

    this.slides = document.createElement('div');
    this.slides.classList = 'swiper-wrapper';

    this.cursor = document.createElement('div');
    this.cursor.classList = '__slider-cursor';
    this.nextBtn = document.createElement('div');
    this.nextBtn.classList = '__next-btn'
    this.prevBtn = document.createElement('div');
    this.prevBtn.classList = '__prev-btn'
    this.cursor.innerHTML = `<svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
    </svg>`;

    this.closeBtn = document.createElement('div');
    this.closeBtn.classList = '__close-btn';
    this.closeBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
      <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
    </svg>`;

    this.allCards.forEach((card, idx) => {
      const slide = document.createElement('div');
      slide.classList = 'swiper-slide';
      const clone = card.querySelector('.for-lightbox').cloneNode(true);
      slide.append(clone);
      this.slides.append(slide);
      card.querySelectorAll('.lightbox-toggle').forEach(btn=>{
        btn.addEventListener('click', (e) => {
          this.toggleLightbox.bind(this)(e, idx);
        });
      })
    });


    this.closeBtn.addEventListener('click', this.toggleLightbox.bind(this));

    this.slider.append(this.slides);
    this.lightbox.append(this.slider);
    this.lightbox.append(this.cursor);
    this.lightbox.append(this.prevBtn);
    this.lightbox.append(this.nextBtn);
    this.lightbox.append(this.closeBtn);
    this.append(this.lightbox);

    this.swiper = Swiper;

    this.addEventListener('mousemove', (e) => {
      this.cursor.style.left = `${e.clientX}px`;
      this.cursor.style.top = `${e.clientY}px`;
      this.toggleCursorDirection.bind(this)(e);
    });

    this.mouseOverFunction = (e) => {
      this.toggleCursorDirection.bind(this)(e);
      this.lightbox.removeEventListener('mouseover', this.mouseOverFunction);
    }

    this.lightbox.addEventListener('click', (e) => {
      if (e.clientX > this.lightbox.offsetWidth / 2) {
        this.nextBtn.click();
      } else {
        this.prevBtn.click();
      }
    });

    this.closeBtn.addEventListener('mouseenter', this.toggleCursorVisibility.bind(this));
    this.closeBtn.addEventListener('mouseleave', this.toggleCursorVisibility.bind(this));

    // this.lightbox.addEventListener('mousedown',(e)=>{
    //   console.log("Mouse is down");
    //   this.toggleCursorVisibility.bind(this)();
    // });
    // this.lightbox.addEventListener('mouseup',this.toggleCursorVisibility.bind(this));
  }

  toggleCursorVisibility(e) {
    this.cursor.classList.toggle('--hide');
  }

  toggleCursorDirection(e) {
    if (e.clientX > this.slider.offsetWidth / 2 && this.cursor.classList.contains('--prev')) {
      this.cursor.classList.remove('--prev');
    } else if (e.clientX < this.slider.offsetWidth / 2 && !this.cursor.classList.contains('--prev')) {
      this.cursor.classList.add('--prev');
    }
  }

  toggleLightbox(e, idx) {
    if (typeof idx === 'undefined') {
      document.body.style.overflow = 'unset';
      this.lightbox.classList.remove('--active');
      this.swiper.destroy();
    } else {
      this.initSwiper(idx);
      this.lightbox.classList.add('--active');
      document.body.style.overflow = 'hidden';
      const contentSizeToggleBtns = this.querySelectorAll(`.${this.uniqueId} .__content-size-options`);
      contentSizeToggleBtns.forEach(element => {
        element.addEventListener('click', (e) => {
          e.stopPropagation();
          e.target.closest('.__content-size-options').classList.toggle('--active');
          e.target.closest('.__slide').querySelector('.__content').classList.toggle('--show-content');
          e.target.closest('.swiper-slide').classList.toggle('swiper-no-swiping');
        });
      })
    }
  }

  initSwiper(start) {
    this.lightbox.addEventListener('mouseover', this.mouseOverFunction);
    this.swiper = new Swiper(`.${this.uniqueId}`, {
      slidesPerView: 1,
      parallax: true,
      speed: 900,
      initialSlide: start,
      loop: true,
      navigation: {
        nextEl: '.__next-btn',
        prevEl: '.__prev-btn'
      }
    });
    this.querySelectorAll(`.${this.uniqueId} .__study-link`).forEach(item => {
      item.addEventListener('mouseenter', this.toggleCursorVisibility.bind(this));
      item.addEventListener('mouseleave', this.toggleCursorVisibility.bind(this));
      item.addEventListener('click', (e) => e.stopPropagation());
    })
  }

  closeSlider() {
    this.swiper.destroy();
  }
}

customElements.define('ingredients-lightbox', IngredientsLightbox);

document.querySelectorAll('.announcement-close-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    btn.closest('.announcement-bar').style.display = 'none';
    const hoveringSelector = document.querySelector('.hovering-selection');
    if (hoveringSelector) {
      hoveringSelector.dispatchEvent(new CustomEvent('ann-bar-closed', {
        bubbles: true
      }));
    }
  })
})

//Hide drawer on click outside of it
document.addEventListener("DOMContentLoaded", () => {

  window.addEventListener('click', function (e) {
    if (document.body.classList.contains('drawer-shown') && e.target.id != "cart-icon-bubble") {
      if (!document.getElementById('cart-preview-drawer').contains(e.target)) {
        // Clicked in box
        document.getElementById('cart-preview-drawer').classList.remove('--active')
        document.body.classList.remove('drawer-shown')
        document.body.style.overflow = "unset"
      }
    }
  });
})


//redirection
window.onload = function() {
  if (localStorage.getItem('hasRedirected')) {
    return;
  }

  fetch('/browsing_context_suggestions.json')
    .then(response => response.json())
    .then(data => {
      const languageCode = data.detected_values.country.handle.toLowerCase();
      if (languageCode === 'es') {
        return;
      }
      const isoLanguage = getISOLanguageFromCode(languageCode);
      localStorage.setItem('hasRedirected', 'true');
      //window.location.href = `https://olisticscience.com//${isoLanguage}`;

    })
    .catch(error => {
      console.error('Error fetching browsing context suggestions:', error);
    });
};

function getISOLanguageFromCode(languageCode) {
  const languageToISO = {
    'us': 'en',
    'de': 'de-de',
    'pt': 'pt-pt'
  };
  return languageToISO[languageCode] || 'en';
}



//Results page
customElements.define("results-page", class ResulstPage extends HTMLElement{
  constructor(){
    super()

    this.sections = this.querySelectorAll('.quiz-master-section')

    !Shopify.designMode && this.init()
  }

  init(){
    
    
    this.sections.forEach(section=>{
      const sectionConfig = section.dataset.configuration.replace("<br />", "")
      const isDegree = section.dataset.is_degree
      if(!sectionConfig){
        return
      }
      const sectionConfigParsed = {}
      sectionConfig && sectionConfig.split(/\r?\n|\r|\n/g).forEach(line=>{
        console.log(line)
        sectionConfigParsed[line.split(" - ")[0]] = line.split(" - ")[1].toString().replace("<br />", "").split(",")
      })

      console.log(sectionConfigParsed)

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      Object.keys(sectionConfigParsed).forEach((key, index)=>{
        const value = urlParams.get(key)
        const matching = Object.values(sectionConfigParsed)[index].includes(value)
        if(!matching){
          section.classList.add("hidden")
        }
        console.log("Matches current quiz?", matching)
      })
    })
  }
})


//Categories scroll
customElements.define("scroll-categories", class ScrollCategories extends HTMLElement{
  constructor(){
    super()

    this.togglers = this.querySelectorAll('.scroll-categories__toggler')

    this.togglers.forEach(item=>item.addEventListener("click", (e)=>this.handleClick(e.target)))
  }

  handleClick(item){
    this.togglers.forEach(item=>item.classList.remove("active"))    
    item.classList.add("active")
    const relatedItem = document.getElementById(`${item.dataset.relatedSection}`)
    console.log(relatedItem)
    console.log(relatedItem.scroll)
    window.scrollTo({
      top: relatedItem.offsetTop - 170,
      behavior: "smooth"
    })
  }
})

//Blog author
customElements.define("blog-author", class BlogAuthor extends HTMLElement{
  constructor(){
    super()

    this.description = this.querySelector(".blog-author__description")
    this.toggler = this.querySelector(".js-open-description")

    window.innerWidth < 991 && this.toggler.addEventListener("click", this.toggleDescription.bind(this))
  }

  toggleDescription(){
    this.classList.toggle("opened-description")
  }
})

class DynamicTitle extends HTMLElement {
  constructor() {
    super();
    this.titles = this.querySelectorAll('.title-item');
    this.currentIndex = 0;
    this.interval = 4000;
    this.startDelay = parseFloat(this.dataset.delay) * 1000; // Get delay from data-delay attribute, default to 0
  }

  connectedCallback() {
    // Add delay before starting the rotation
    console.log(this.startDelay)
    setTimeout(() => {
      this.startRotation();
    }, this.startDelay);
  }

  startRotation() {
    setInterval(() => {
      const current = this.titles[this.currentIndex];
      current.classList.remove('active');
      current.classList.add('inactive');
      
      setTimeout(() => {
        current.classList.remove('inactive');
      }, 500);

      this.currentIndex = (this.currentIndex + 1) % this.titles.length;
      
      const next = this.titles[this.currentIndex];
      next.classList.add('active');
    }, this.interval);
  }
}

customElements.define('dynamic-title', DynamicTitle);

class CartSubscriptionUpsell extends HTMLElement {
  constructor() {
      super();
      this.button = this.querySelector('.cart-item-upsell__button');
      this.bindEvents();
  }

  bindEvents() {
      this.button?.addEventListener('click', this.handleClick.bind(this));
  }

  async handleClick(e) {
      e.preventDefault();
      e.stopPropagation();

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const currentKey = this.button.dataset.currentKey;
      const quantity = parseInt(this.button.dataset.currentQuantity);
      const subscriptionId = this.button.dataset.subscriptionId;
      const sellingPlanId = this.button.dataset.subscriptionSellingPlan;

      try {
          // Remove current item and add subscription variant
          const removeResponse = await this.removeCurrentItem(currentKey);
          const addResponse = await this.addSubscriptionItem(subscriptionId, quantity, sellingPlanId);
          
          if (cart && 'renderContents' in cart) {
              cart.renderContents(addResponse);
          }
      } catch (error) {
          console.error('Error updating cart:', error);
      }
  }

  async removeCurrentItem(key) {
      return fetch(`${routes.cart_change_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
              id: key,
              quantity: 0
          })
      }).then(res => res.json());
  }

  async addSubscriptionItem(id, quantity, sellingPlan) {
      return fetch(`${routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
              items: [{
                  id: id,
                  quantity: quantity,
                  selling_plan: sellingPlan
              }],
              sections: "cart-drawer,cart-icon-bubble"
          })
      }).then(res => res.json());
  }
}

customElements.define('cart-subscription-upsell', CartSubscriptionUpsell);



class ProductFixedAtc extends HTMLElement{
  constructor(){
      super()

      this.productFormBtn = document.querySelector('.js-add-to-cart')
      this.productForm = document.querySelector('.product-form')
      this.stickyAtcBtn = this.querySelector('.add-to-cart-btn')
      
      this.init()
  }

  init(){
      this.productFormBtn = document.querySelector('.js-add-to-cart')
      this.productForm = document.querySelector('.product-form')
      this.stickyAtcBtn = this.querySelector('.add-to-cart-btn')


      this.stickyAtcBtn.addEventListener("click", ()=>{
          this.productFormBtn.click()
      })

      window.addEventListener("scroll", ()=>{
          if(window.scrollY > 10){
              this.classList.add("shown")
          }else{
              this.classList.remove("shown")
          }

          //If reached bottom of page, remove class .shown
          if(window.scrollY + window.innerHeight >= document.body.scrollHeight){
            this.classList.remove("shown")
          }
      })

      if(window.scrollY > 10){
        this.classList.add("shown")
      }
  }
}

customElements.define('product-fixed-atc', ProductFixedAtc)


customElements.define("cart-night-switcher", class CartNightSwitcher extends HTMLElement {
  constructor() {
      super();

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      this.addEventListener("click", async ()=>{
        await this.removeCurrentItem(this.dataset.currentKey);
        const addResponse = await this.addRegularItem(this.dataset.variantId, this.dataset.currentQuantity, this.dataset.subscriptionSellingPlan);

        if (this.cart && 'renderContents' in this.cart) {
          this.cart.renderContents(addResponse);
        }
      });
  }

  async removeCurrentItem(key) {
      return fetch(`${routes.cart_change_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
              id: key,
              quantity: 0
          })
      }).then(res => res.json());
  }

  async addRegularItem(id, quantity, sellingPlan) {
      const body = {
          items: [{
              id: id,
              quantity: quantity,
          }],
          sections: "cart-drawer,cart-icon-bubble"
      }

      if(sellingPlan) {
          body.items[0].selling_plan = sellingPlan;
      }

      return fetch(`${routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
      }).then(res => res.json());
  }
});

customElements.define("product-dropdown", class ProductDropdown extends HTMLElement{
  constructor(){
      super()

      this.toggler = this.querySelector('.product-dropdown__toggler')
      this.contentWrapper = this.querySelector('.product-dropdown__content')
      this.contentInner = this.querySelector('.product-dropdown__content-inner')

      console.log("heeee", this)

      this.toggler.addEventListener("click", this.toggle.bind(this))
  }


  toggle(){
      if(this.classList.contains('open')){
          this.close()
      }else{
          this.open()
      }
  }

  open(){
      this.style.setProperty("--content-height", this.contentInner.offsetHeight + "px")
      this.classList.add('open')
  }

  close(){
      this.style.setProperty("--content-height", 0 + "px")
      this.classList.remove('open')
  }
})


customElements.define("product-gallery", class ProductGallery extends HTMLElement{
  constructor(){
    super()

    this.thumbnails = this.querySelectorAll('.product-gallery__thumbnail')
    this.hasHatBar = this.querySelector('.hat-bar')

    this.thumbnails.forEach(thumbnail=>{
      thumbnail.addEventListener('click', ()=>{
        this.swiper.slideTo(thumbnail.dataset.index)
      })
    })

    this.swiper = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 1,
      pagination: {
        el: '.product-gallery__pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.product-gallery__next',
        prevEl: '.product-gallery__prev',
      },
      on: {
        slideChange: (e)=>{
          console.log(e)
          if(this.hasHatBar && window.innerWidth < 768 && e.activeIndex == 0){
            this.querySelector('.product-gallery__pagination').style.bottom = "40px"
          }else{
            this.querySelector('.product-gallery__pagination').style.bottom = "10px"
          }
        },
        init: ()=>{
          if(this.hasHatBar && window.innerWidth < 768){
            this.querySelector('.product-gallery__pagination').style.bottom = "40px"
          }
        }
      }
    })
  }
})


customElements.define("section-banner", class SectionBanner extends HTMLElement{
  constructor(){
    super()

    this.banner = this.querySelector('.custom-banner')
    this.bannerContent = this.querySelector('.custom-banner__content')

    this.setBannerHeight()
    window.addEventListener("resize", this.setBannerHeight.bind(this))
  }

  setBannerHeight(){
    this.banner.style.minHeight = `${this.bannerContent.offsetHeight}px`
    this.banner.style.setProperty("--banner-height", `${this.bannerContent.offsetHeight}px`)
  }
})


customElements.define("color-swatch", class ColorSwatch extends HTMLElement{
  constructor(){
    super()

    this.url = this.dataset.url
    this.sectionId = this.dataset.sectionId

    this.addEventListener("click", ()=>{
      console.log("clicked", this.url, this.sectionId)
      fetch(this.url + "?section_id=" + this.sectionId)
      .then(res=>res.text())
      .then(res=>{
        const newPdp = document.createElement("html")
        newPdp.innerHTML = res
        const newPdpWrapper = newPdp.querySelector('.main-product-selector')
        const currentPdp = document.querySelector(`.main-product-selector`)
        currentPdp.outerHTML = newPdpWrapper.outerHTML
        window.history.pushState({}, "", this.url)
      })
    })
  }
})

customElements.define("gwp-product-block", class GwpProductBlock extends HTMLElement{
  constructor(){
    super()

    this.type = this.dataset.type == "mensual" ? 0 : 1
    this.addEventListener("click", ()=>{
      document.querySelector('.main-product-selector').querySelectorAll('form')[this.type].querySelector('.js-select-purchase-option').click()
    })
  }
})


customElements.define("calendar-switcher", class CalendarSwitcher extends HTMLElement{
  constructor(){
    super()

    this.sectionId = this.dataset.sectionId
    this.switchers = this.querySelectorAll('.advent-calendar-btn')

    this.switchers.forEach(switcher=>{
      switcher.addEventListener("click", ()=>{

        console.log("clicked", switcher.dataset.url)
        if(!switcher.dataset.url) return;
        fetch(switcher.dataset.url + "?section_id=" + this.sectionId)
        .then(res=>res.text())
        .then(res=>{
          const newPdp = document.createElement("html")
          newPdp.innerHTML = res
          const newPdpWrapper = newPdp.querySelector('.main-product-selector')
          const currentPdp = document.querySelector(`.main-product-selector`)
          currentPdp.outerHTML = newPdpWrapper.outerHTML
          window.history.pushState({}, "", switcher.dataset.url)
        })
      })
    })
  }
})



customElements.define("ingredients-spotlight", class IngredientsSpotlight extends HTMLElement{
  constructor(){
    super()

    this.tabs = this.querySelectorAll('.ingredients-spotlight__tab')
    this.ingredients = this.querySelectorAll('.ingredients-spotlight__ingredient')
    this.ingredientsMobile = this.querySelectorAll('.hidden-desktop .ingredients-spotlight__ingredient')
    this.controls = this.querySelector('.ingredients-spotlight__controls')
    this.limit = window.innerWidth < 1200 ? 8 : 12;

    // Fix parsing error: wrap the section JSON in array brackets if not present
    let rawSliderConfig = document.getElementById(`IngredientsSpotlight-${this.dataset.sectionId}`).textContent.trim();

    // If not an array, force into array (assume it's multiple objects separated by commas)
    if (!rawSliderConfig.startsWith('[')) {
      rawSliderConfig = `[${rawSliderConfig}]`;
    }

    try {
      this.sliderConfig = JSON.parse(rawSliderConfig);
    } catch (e) {
      console.error("Failed to parse IngredientsSpotlight JSON:", e, rawSliderConfig);
      this.sliderConfig = [];
    }

    this.init()
    this.tabs.forEach(tab=>{
      tab.addEventListener('click', ()=>{
        this.changeTab(tab)
      })
    })

  }

  changeTab(tab){
    this.tabs.forEach(t=>t.classList.remove('active'))
    tab.classList.add('active')

    this.updateSlides(tab.dataset.tab)
    this.updateMobileGrid(tab.dataset.tab)
  }

  init(){
    this.querySelector('.swiper-wrapper').innerHTML = this.sliderHtml(this.sliderConfig, 'all', this.limit)
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: '.ingredients-spotlight__pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.ingredients-spotlight__next',
        prevEl: '.ingredients-spotlight__prev',
      }
    })
  }

  updateMobileGrid(type){
    console.log("updating mobile grid", type, this.ingredientsMobile)
    this.ingredientsMobile.forEach((ingredient, index)=>{
      if(type == 'all'){
        index < 12 && ingredient.classList.remove('hidden')
      }else{
        index < 12 && ingredient.classList.toggle('hidden', ingredient.dataset.type != type)
      }
    })
    const shownIngredients = Array.from(this.ingredientsMobile).filter(ingredient=>!ingredient.classList.contains('hidden'))
    console.log("shownIngredients", shownIngredients.length)
    if(shownIngredients.length <12){
      this.querySelector('.ingredients-spotlight__right .link').style.display = 'none'
    }else{
      this.querySelector('.ingredients-spotlight__right .link').style.display = 'flex'
    }
  }

  updateSlides(type){
    console.log("updating slides", type, this.limit)
    this.querySelector('.swiper-wrapper').innerHTML = this.sliderHtml(this.sliderConfig, type, this.limit)
    this.swiper.update()
  }


  sliderHtml(slides, type, limit = 12){
    let html = ''
    if(type == 'all'){
      html = '';
      for (let i = 0; i < slides.length; i += limit) {
        html += `<div class="ingredients-spotlight__ingredient__grid swiper-slide">`;
        html += slides.slice(i, i + limit).map(slide => `
          <div class="ingredients-spotlight__ingredient">
            <img src="${slide.image}" alt="${slide.title}" class="ingredients-spotlight__ingredient__image">
            <span class="text-small">${slide.title}</span>
          </div>
        `).join('');
        html += `</div>`;
      }
    }else{
      html = '';
      for (let i = 0; i < slides.length; i += limit) {
        if(slides[i].type == type){
          html += `<div class="ingredients-spotlight__ingredient__grid swiper-slide">`;
          html += slides.slice(i, i + limit).map(slide => `
            <div class="ingredients-spotlight__ingredient">
              <img src="${slide.image}" alt="${slide.title}" class="ingredients-spotlight__ingredient__image">
              <span class="text-small">${slide.title}</span>
            </div>
          `).join('');
          html += `</div>`;
        }
      }
    }
    return html
  }
})
